import { render } from "./Children.vue?vue&type=template&id=38b664c4&ts=true"
import script from "./Children.vue?vue&type=script&lang=ts"
export * from "./Children.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__